import { render, staticRenderFns } from "./PersonIcon.vue?vue&type=template&id=485086b4&scoped=true&"
import script from "./PersonIcon.vue?vue&type=script&lang=js&"
export * from "./PersonIcon.vue?vue&type=script&lang=js&"
import style0 from "./PersonIcon.vue?vue&type=style&index=0&id=485086b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485086b4",
  null
  
)

export default component.exports